var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsInt, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { CustomFormElementType } from '../enums/custom-form-element-type.enum.js';
import { CustomFormElementAnswerLiteDto } from './custom-form-element-answer.lite.dto.js';
class Options {
    id;
    value;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], Options.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], Options.prototype, "value", void 0);
/**
 * @deprecated Use dedicated Response DTOs instead.
 */
export class CustomFormElementFullSizeDto {
    id;
    createdAt;
    updatedAt;
    label;
    /** @deprecated Used for migration from legacy Anamnesis to CustomForm */
    migrationLabel;
    index;
    options;
    mandatory;
    isNewlyCreated;
    type;
    customForm;
    customFormElementAnswers;
    customFormId;
    customFormSectionId;
    imageFilename;
    description;
    placeholder;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormElementFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormElementFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormElementFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormElementFullSizeDto.prototype, "label", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", Object)
], CustomFormElementFullSizeDto.prototype, "migrationLabel", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], CustomFormElementFullSizeDto.prototype, "index", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Options),
    __metadata("design:type", Array)
], CustomFormElementFullSizeDto.prototype, "options", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormElementFullSizeDto.prototype, "mandatory", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CustomFormElementFullSizeDto.prototype, "isNewlyCreated", void 0);
__decorate([
    Expose(),
    IsEnum(CustomFormElementType),
    __metadata("design:type", String)
], CustomFormElementFullSizeDto.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Function)
], CustomFormElementFullSizeDto.prototype, "customForm", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => CustomFormElementAnswerLiteDto),
    __metadata("design:type", Array)
], CustomFormElementFullSizeDto.prototype, "customFormElementAnswers", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormElementFullSizeDto.prototype, "customFormId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], CustomFormElementFullSizeDto.prototype, "customFormSectionId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementFullSizeDto.prototype, "imageFilename", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementFullSizeDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CustomFormElementFullSizeDto.prototype, "placeholder", void 0);
//# sourceMappingURL=custom-form-element.full-size.dto.js.map